/**
 * Lookups 유틸리티 - 상수는 constants/index.ts에서 가져옴
 */
import { ACCEPT_STATUS_LABEL, SERVICE_SORTATION } from '../constants';

// 하위 호환성을 위해 재export
export { ACCEPT_STATUS_LABEL as ACCEPT_STATUS, SERVICE_SORTATION };

export function getAcceptLabel(code?: string | null): string {
  if (code === undefined || code === null) return '';
  return ACCEPT_STATUS_LABEL[String(code)] || String(code);
}

export function getServiceLabel(code?: string | null): string {
  if (code === undefined || code === null) return '미분류';
  const key = String(code);
  if (key === 'null') return '미분류';
  return SERVICE_SORTATION[key] || '미분류';
}
